<template>
  <card id="applicatie" ref="applicationref">
    <h2 slot="header" class="card-title">{{$t('applications.admin__applications')}}</h2>
    <div class="row">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div>
                <el-select class="filter-select mr-2" v-model="filters.status" placeholder="Filter by status" clearable @change="handleFilters">
                  <el-option v-for="item in filterOptions.status" :key="item.value" :label="item.text + ' ('+item.total+')'" :value="item.value"/>
                </el-select>
                <el-select class="filter-select mr-2" v-model="filters.regions" multiple collapse-tags placeholder="Filter by regions" clearable @change="handleFilters">
                  <el-option v-for="item in filterOptions.regions" :key="item.value" :label="item.text + ' ('+item.total+')'" :value="item.value"/>
                </el-select>
                <el-select class="filter-select mr-2" v-model="filters.countries" multiple collapse-tags placeholder="Filter by countries" clearable @change="handleFilters">
                  <el-option v-for="item in filterOptions.countries" :key="item.value" :label="item.text + ' ('+item.total+')'" :value="item.value"/>
                </el-select>
                <el-select class="filter-select mr-2" v-model="filters.language" placeholder="Filter by language" clearable @change="handleFilters">
                  <el-option v-for="item in filterOptions.language" :key="item.value" :label="item.text + ' ('+item.total+')'" :value="item.value"/>
                </el-select>
              </div>
              <base-input>
                <el-input
                  type="text"
                  class="mb-3 search-input"
                  prefix-icon="el-icon-search"
                  placeholder="Search and hit enter"
                  v-model="searchQuery"
                  @keyup.native.enter="getItems(1)"
                >
                </el-input>
              </base-input>
            </div>
            <el-table :data="applications" @sort-change="handleSort">
              <el-table-column type="expand">
                <template slot-scope="props">
                  <div>Name:
                    <a class="link-text" @click="viewUserProfile(props.row.user_details.id)"> {{ props.row.user_details.name }}</a>
                  </div>
                  <div>Email: {{ props.row.user_details.email }}</div>
                  <div>Language:
                    <flag :iso="languages[props.row.user_details.language].flag" v-bind:squared=false></flag>
                    {{ props.row.user_details.language }}
                  </div>
                  <div>Phone: {{ props.row.user_details.phone }}</div>
                  <div class="mt-2">
                    Evaluations:
                  </div>
                  <ol>
                    <li v-for="evaluationType in evaluationTypes" :key="evaluationType.id">
                      <a @click="evaluateApplication(props.row, evaluationType)" class="pl-1 link-text"> {{evaluationType.name}} </a>
                      <ul class="evaluations-list">
                        <li v-if="applicationEvaluation.type.nickname === evaluationType.nickname" v-for="applicationEvaluation in props.row.evaluations" :key="applicationEvaluation.id">
                          <span v-if="evaluationType.nickname === 'technical' || evaluationType.nickname === 'fp_technical'">
                  <a @click="evaluateApplication(props.row, evaluationType, applicationEvaluation.user_id)" class="pl-1 link-text"> {{applicationEvaluation.status}} </a>
                ({{applicationEvaluation.user.name}})
              </span> <span v-else>{{applicationEvaluation.status}} ({{applicationEvaluation.user.name}})</span>
                        </li>
                      </ul>
                    </li>
                  </ol>
                </template>
              </el-table-column>
              <el-table-column
                sortable
                label="Reference"
                min-width="50"
                property="reference"
              ></el-table-column>
              <el-table-column
                sortable
                label="Title"
                property="title"
                prop="title"
              ></el-table-column>
              <el-table-column
                label="Organisation"
                property="user_details.fields.organisation_legal_name"
              >
                <div slot-scope="props" v-if="props.row.user_details.fields">
                  {{props.row.user_details.fields.organisation_legal_name}}
                </div>
              </el-table-column>
              <el-table-column
                label="Objectives"
                max-width="50"
                property="objectives"
              ></el-table-column>
              <el-table-column
                sortable
                label="Status"
                max-width="50"
                property="status"
              >
                <div slot-scope="props">
                  <span v-if="props.row.status === 'submitted'" class="badge badge-success">{{props.row.status}}</span>
                  <span v-if="props.row.status !== 'submitted'" class="badge">{{props.row.status}}</span>
                </div>
              </el-table-column>
              <el-table-column
                sortable
                label="Last Update"
                max-width="50"
                property="updated_at"
              ></el-table-column>
              <el-table-column align="right" min-width="150" label="Actions">
                <div slot-scope="props">
                  <div class="card-body">
                    <div>
                      <div class="btn-group">
                        <base-button
                          class="mb-1"
                          type="info"
                          size="sm"
                          @click="viewApplication(props.row)"
                        >
                          <i class="tim-icons icon-zoom-split"></i> View
                        </base-button>
                        <base-button
                          title="Open in new tab"
                          class="mb-1"
                          type="info"
                          size="sm"
                          @click="viewApplication(props.row, true)"
                        >
                          <i class="tim-icons icon-tap-02"></i>
                        </base-button>
                      </div>
                    </div>
                    <base-button
                      class="mb-1"
                      type="warning"
                      size="sm"
                      @click="evaluateApplicationModal(props.row)"
                    >
                      <i class="tim-icons icon-paper"></i> Evaluate
                    </base-button>
                    <base-button
                      class="mb-1"
                      type="success"
                      size="sm"
                      @click="requestClarifications(props.row)"
                    >
                      <i class="tim-icons icon-alert-circle-exc"></i> Request Clarifications
                    </base-button>
                  </div>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                Showing {{ pagination.from }} to {{ pagination.to }} of {{ pagination.total }} entries
              </p>
            </div>
            <base-pagination
              v-if="applications.length"
              @input="getItems"
              class="pagination-no-border"
              v-model="pagination.current_page"
              :per-page="pagination.per_page"
              :total="pagination.total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <modal
      :show.sync="modalEvaluate.visibility"
      headerClasses="justify-content-center"
    >
      <h4 slot="header" class="title">Evaluate application: <strong>{{modalEvaluate.application.reference}}</strong>
      </h4>
      <ol>
        <li v-for="evaluationType in evaluationTypes" :key="evaluationType.id">
          <a @click="evaluateApplication(modalEvaluate.application, evaluationType)" class="pl-1 link-text"> {{evaluationType.name}} </a>
          <ul class="evaluations-list">
            <li v-if="applicationEvaluation.type.nickname === evaluationType.nickname" v-for="applicationEvaluation in modalEvaluate.application.evaluations" :key="applicationEvaluation.id">
              <span v-if="evaluationType.nickname === 'technical' || evaluationType.nickname === 'fp_technical'">
                  <a @click="evaluateApplication(modalEvaluate.application, evaluationType, applicationEvaluation.user_id)" class="pl-1 link-text"> {{applicationEvaluation.status}} </a>
                ({{applicationEvaluation.user.name}})
              </span> <span v-else>{{applicationEvaluation.status}} ({{applicationEvaluation.user.name}})</span>
            </li>
          </ul>
        </li>
      </ol>

      <div class="mt-2 text-right">
        <base-button
          type="danger"
          @click.native="modalEvaluate.visibility = false"
        >Close
        </base-button>
      </div>
    </modal>

  </card>
</template>
<script>
  import {Table, TableColumn, Select, Option} from 'element-ui';
  import {Modal} from 'src/components';
  import {BasePagination} from 'src/components';
  import {ApplicationService, EvaluationService} from '@/services';

  export default {
    components: {
      BasePagination,
      [Select.name]: Select,
      [Option.name]: Option,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      Modal
    },
    data() {
      return {
        initialized: false,
        pagination: {},
        sortColumn: undefined,
        sortOrder: undefined,
        perPage: 16,
        searchQuery: undefined,
        propsToSearch: ['reference', 'title', 'user_details.email', 'user_details.name', 'user_details.organisation_legal_name', 'region_details.name', 'countries.name', 'status'],
        applications: [],
        filterOptions: [],
        filters: {
          status: undefined,
          countries: [],
          regions: [],
          language: undefined
        },
        evaluationTypes: [],
        modalEvaluate: {
          visibility: false,
          application: {}
        }
      };
    },
    computed: {
      languages: function () {
        let availableLanguages = this.$store.getters['Localization/languages'];
        let languages = [];
        for (let key in availableLanguages) {
          languages[availableLanguages[key].language] = availableLanguages[key];
        }
        return languages;
      }
    },
    methods: {
      async getItems(page) {
        let vm = this;
        let page_to_get = page || vm.pagination.current_page;

        let loader = vm.$loading.show();

        await ApplicationService.getApplications({
          page: page_to_get,
          per_page: vm.perPage,
          search: vm.searchQuery,
          sort_column: vm.sortColumn,
          sort_direction: vm.sortDirection,
          filter_status: vm.filters.status,
          filter_regions: vm.filters.regions,
          filter_countries: vm.filters.countries,
          filter_language: vm.filters.language,
        }).then((response) => {
          vm.pagination = response.data.meta;
          vm.applications = response.data.data;
        })

        await vm.getFilters();

        loader.hide();
      },
      async getFilters() {
        let vm = this;
        return await ApplicationService.getFilters({
          search: vm.searchQuery,
          filter_status: vm.filters.status,
          filter_regions: vm.filters.regions,
          filter_countries: vm.filters.countries,
          filter_language: vm.filters.language,
        }).then((response) => {
          vm.filterOptions = response.data;
        })
      },
      async getEvaluationTypes() {
        let vm = this;
        let response = await EvaluationService.getEvaluationTypes();
        vm.evaluationTypes = response.data;
      },
      handleFilters() {
        let vm = this;
        vm.getItems(1);
      },
      handleSort(data) {
        let vm = this;
        let direction = null;
        if (data.order === 'ascending') {
          direction = 'asc';
        } else if (data.order === 'descending') {
          direction = 'desc';
        }
        vm.sortColumn = data.prop;
        vm.sortDirection = direction;
        vm.getItems(1);
      },
      viewUserProfile(userId) {
        this.$router.push('/users-management/view-profile/' + userId);
      },
      viewApplication(application, openInNewTab) {
        if (openInNewTab) {
          window.open('/application/fill/' + application.grant_id + '/' + application.application_id, '_blank');
        } else {
          this.$router.push('/application/fill/' + application.grant_id + '/' + application.application_id);
        }
      },
      evaluateApplicationModal(application) {
        let vm = this;
        vm.modalEvaluate.visibility = true;
        vm.modalEvaluate.application = application;
      },
      evaluateApplication(application, evaluationType, evaluationUserId) {
        if(evaluationUserId) {
          window.open('/application/evaluate/' + evaluationType.nickname + '/' + application.application_id + '/' + evaluationUserId, '_blank');
        } else {
          window.open('/application/evaluate/' + evaluationType.nickname + '/' + application.application_id, '_blank');
        }
      },
      requestClarifications(application) {
        this.$router.push('/clarifications/fill/' + application.application_id);
      }
    },
    mounted() {
      let vm = this;
      vm.getItems();
      vm.getEvaluationTypes();
    }
  };
</script>
<style lang="scss" scoped>
  .card-body {
    button {
      margin-left: 1rem;
    }
  }

  button {
    white-space: nowrap;
  }

  .evaluations-list {
    list-style-type: disc !important;
  }
</style>
